import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import AuthorsListContainer from '../AuthorsList/AuthorsListContainer';
import Headline from '../Headline/Headline';
import Header from '../Header';
import Overview from '../Overview';
import Body from '../Body/Body';
import DocumentMeta from '../DocumentMeta';
import Navigation from './Navigation';

if (process.browser) require('./Document.scss');

export default function Document({
  identifier,
  doc,
}) {
  const track = {
    context: 'Document',
    value: {
      documentId: doc.id,
    },
  };

  const AuthorsList = () => (
    <AuthorsListContainer
      doc={doc}
      track={track}
      withColumns
    />
  );

  const DocumentOverview = () => (
    <Overview doc={doc} />
  );

  return (
    <div className="document" data-name="document">
      <DocumentMeta doc={doc} />
      <Headline>
        <Header doc={doc} />
      </Headline>
      <Navigation track={track} doc={doc} identifier={identifier} />
      <Body>
        <Switch>
          <Route exact path="/:identifier/" component={DocumentOverview} />
          <Route exact path="/:identifier/authors" component={AuthorsList} />
        </Switch>
      </Body>
    </div>
  );
}

Document.propTypes = {
  identifier: PropTypes.string.isRequired,
  doc: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/universal/ui/components/Document/Document.js